import { render, staticRenderFns } from "./addComment.vue?vue&type=template&id=38bf7834&scoped=true"
import script from "./addComment.vue?vue&type=script&lang=js"
export * from "./addComment.vue?vue&type=script&lang=js"
import style0 from "./addComment.vue?vue&type=style&index=0&id=38bf7834&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bf7834",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38bf7834')) {
      api.createRecord('38bf7834', component.options)
    } else {
      api.reload('38bf7834', component.options)
    }
    module.hot.accept("./addComment.vue?vue&type=template&id=38bf7834&scoped=true", function () {
      api.rerender('38bf7834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shopManagement/shopComment/addComment.vue"
export default component.exports